
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, InjectFunction } from "@common/src/utils/decorator";
import ConfirmPaymentItem from "./components/confirm-payment.vue";
import RegisterInvoice from "./components/register-invoice.vue";
import t from "@common/src/i18n/t";
import InWarehouseConfirm from "./components/in-warehouse-confirm.vue";

const service = namespace("service");
const base = namespace("base");
const staff = namespace("staff");
const purchase = namespace("purchase");
const supplier = namespace("supplier");
const parts = namespace("parts");
const app = namespace("app");

@InjectFunction("dayjs", "emptyToLine", "splitThousands", "addCurrencySymbol")
@Component({
  components: { ConfirmPaymentItem, RegisterInvoice, InWarehouseConfirm }
})
@Table("loadListData")
export default class PurchaseList extends Vue {
  @base.Action getDictionaryList;
  @staff.Action getStaffList;
  @purchase.Action purchaseComplete;
  @purchase.Action getPurchaseList;
  @supplier.Action getSupplierList;
  @service.Action createInvoice;
  @purchase.Action createPurchasePayment;
  @purchase.Mutation setPaymentBtnLoading;
  @purchase.Mutation setMakeInvoiceBtnLoading;
  @purchase.Action getPurchaseDetail;
  @parts.Action getPartsList;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @purchase.Action purchaseBatchCompleted;
  @base.Action jumpPrintPage;
  orderList: any[] = [];
  searchForm = {
    purchaseNo: "",
    orderNo: "",
    supplierCode: "",
    purchaseStatus: "",
    settlementStatus: "",
    purchaseDateBegin: "",
    purchaseDateEnd: ""
  };
  showComfirmPayment: boolean = false;
  showRegisterInvoice: boolean = false;
  showInwarehouse: boolean = false;
  orderStatusList: any[] = [];
  handlePaymentConfirmClick(data) {
    let params = {
      orderList:
        data.settleType === 1
          ? [{ orderNo: this.willUpdateRow.purchaseNo }]
          : data.selectedRows.map(item => {
              item.orderNo = item.purchaseNo;
              return item;
            }),
      paidList: [
        {
          paidAmount: data.settleType === 1 ? data.paidAmount : 0,
          paidMethod: data.paidMethod
        }
      ],
      remark: ""
    };
    this.setPaymentBtnLoading(true);
    this.createPurchasePayment(params)
      .then(() => {
        this.$message.success(t("base.payment-success") as string);
        this.showComfirmPayment = false;
        this.loadListData();
      })
      .finally(() => {
        this.setPaymentBtnLoading(false);
      });
  }
  handleInvoiceConfirmClick(data) {
    this.setMakeInvoiceBtnLoading(true);
    this.createInvoice(data)
      .then(() => {
        this.$message.success(t("purchase.invoice-register-success") as string);
        this.showRegisterInvoice = false;
        this.loadListData();
      })
      .finally(() => {
        this.setMakeInvoiceBtnLoading(false);
      });
  }
  partsHasZero: boolean = false;
  handleComfirmCommand(command) {
    switch (command) {
      case "payment":
        this.showComfirmPayment = true;
        break;
      case "invoice":
        this.showRegisterInvoice = true;
        break;
      case "print":
        this.jumpPrintPage({ category: "PRINT_PURCHASE", documentNo: this.willUpdateRow.purchaseNo });
        break;
      default:
        // 确认入库
        if (
          this.willUpdateRow.detailList &&
          this.willUpdateRow.detailList.some(parts => {
            return Number(parts.costPrice) === 0;
          })
        ) {
          this.partsHasZero = true;
        }
        this.showInwarehouse = true;
    }
  }
  created() {
    this.init();
    this.loadListData();
  }
  settlementList: any = [];
  init() {
    // 获取供应商
    this.searchSupplier();
    this.searchPartsList();
    // 结算方式字典List
    this.getDictionaryList("purchase_settlement_status").then(data => {
      this.settlementList = data;
    });
    // 订单状态字典List
    this.getDictionaryList("purchase_status").then(data => {
      this.orderStatusList = data;
    });
  }
  totalPurchaseAmount = "";
  @Table.LoadDataMethod()
  loadListData() {
    return this.getPurchaseList({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = data.data.list;
      this.totalPurchaseAmount = this.$safeValue(data, "data.totalPurchaseAmount", "");
      return data;
    });
  }
  handleSwitchStatus() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  handleComplete(selectionRows) {
    this.btnStartLoading();
    let completedFunc;
    if (selectionRows?.length) {
      completedFunc = () => {
        return this.purchaseBatchCompleted({ purchaseNoList: selectionRows.map(item => item.purchaseNo) });
      };
    } else {
      completedFunc = () => {
        return this.purchaseComplete({
          purchaseNo: this.willUpdateRow.purchaseNo
        });
      };
    }
    completedFunc()
      .then(() => {
        this.showInwarehouse = false;
        this.$message.success(t("warehouse.inbound-success") as string);
        this.loadListData();
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  get searchList() {
    return [
      {
        label: t("purchase.purchase-no"),
        type: "input",
        value: "",
        prop: "purchaseNo"
      },
      {
        label: t("other.relation-service-order-number"),
        type: "input",
        value: "",
        prop: "orderNo"
      },
      {
        label: t("supplier.name"),
        type: "select-search",
        value: "",
        prop: "supplierCode",
        placeholder: t("v212.enter-supplier-name/business-commodity/business-scope-query"),
        selectList: this.supplierList,
        searchFun: this.searchSupplier
      },
      {
        label: t("v216_6.procurement-status"),
        type: "select",
        selectList: this.orderStatusList,
        value: "",
        prop: "purchaseStatus"
      },
      {
        label: t("v210906.purchase-spare-parts"),
        type: "select-search",
        value: "",
        prop: "partsCode",
        placeholder: t("v210901.enter-spare-parts-search"),
        selectList: this.partsList,
        searchFun: this.searchPartsList
      },
      {
        label: "base.settlement-status",
        type: "select",
        selectList: this.settlementList,
        value: "",
        prop: "settlementStatus"
      },
      {
        label: "purchase.purchase-date",
        type: "daterange",
        value: "",
        prop: "purchaseDate"
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "purchaseDate") {
          this.searchForm["purchaseDateBegin"] = item.value ? item.value[0] : "";
          this.searchForm["purchaseDateEnd"] = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  partsList: any = [];
  searchPartsList(val = "") {
    this.getPartsList({
      pageNum: 1,
      pageSize: 10,
      partsName: val
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []).map(item => {
        item.label = item.partsName;
        item.value = item.partsCode;
        return item;
      });
    });
  }
  supplierList: any = [];
  searchSupplier(val = "") {
    this.getSupplierList({
      pageNum: 1,
      pageSize: 10,
      searchKey: val
    }).then(data => {
      this.supplierList = this.$safeValue(data, "data.list", []).map(item => {
        item.label = item.supplierName;
        item.value = item.supplierCode;
        return item;
      });
    });
  }
  willUpdateRow: any = {};
  purchaseReturnList: any = [];
  handleSetCurrentRow(visible, row) {
    if (visible) {
      this.willUpdateRow = row;
      this.partsHasZero = false;
      this.getPurchaseDetail({
        purchaseNo: row.purchaseNo
      }).then(data => {
        this.purchaseReturnList = data.data.purchaseReturnList;
      });
    }
  }
  handleEdit(row) {
    this.$router.push(`/purchase/purchase-edit/${row.purchaseNo}`);
  }
  handleLinkOrderView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/purchase/purchase-view/${row.purchaseNo}`
    });
    window.open(href, "_blank");
  }
}
